import { createContext } from "react";

export interface SessionContextType {
  sessionId: string | null;
  recordAction: (
    actionType: string,
    metadata?: Record<string, unknown>,
  ) => void;
}

export const SessionContext = createContext<SessionContextType | undefined>(
  undefined,
);
